/* Learn pages: tidy legacy article HTML, video facades, image lightbox, reading progress,
   guide chapters with a live table of contents, blog search and share. */
(() => {
  if (window.__tcLearn) return; window.__tcLearn = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const WPM = 220;
  const blank = (el) => !el.querySelector('img, iframe, video, picture, svg, table, hr') && !el.textContent.replace(/[\s ​﻿]/g, '');

  /* ---------- Clean legacy HTML ---------- */
  const ytId = (src) => { const m = (src || '').match(/(?:youtube(?:-nocookie)?\.com\/(?:embed\/|watch\?v=)|youtu\.be\/)([\w-]{6,})/); return m ? m[1] : null; };
  const playIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 4l15 8-15 8z"/></svg>';

  const facade = (iframe, poster, label) => {
    const id = ytId(iframe.getAttribute('src'));
    const wrap = document.createElement('div');
    if (!id) { wrap.className = 'tc-embed tc-embed--raw'; iframe.replaceWith(wrap); wrap.append(iframe); return wrap; }
    wrap.className = 'tc-embed';
    const title = iframe.getAttribute('title') || label || 'video';
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'tc-play'; btn.setAttribute('aria-label', `Play ${title}`);
    btn.innerHTML = `<img src="${poster || `https://i.ytimg.com/vi/${id}/hqdefault.jpg`}" alt="" loading="lazy" decoding="async"><span class="tc-play__btn">${playIcon}</span><span class="tc-play__label">${label || 'Watch'}</span>`;
    btn.addEventListener('click', () => {
      const f = document.createElement('iframe');
      f.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
      f.title = title; f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'; f.allowFullscreen = true;
      btn.replaceWith(f);
    }, { once: true });
    wrap.append(btn);
    iframe.replaceWith(wrap);
    return wrap;
  };

  const clean = (root, opts = {}) => {
    root.querySelectorAll('meta, script, style, br + br').forEach((n) => n.remove());
    root.querySelectorAll('[style]').forEach((n) => n.removeAttribute('style'));
    root.querySelectorAll('[align]').forEach((n) => n.removeAttribute('align'));
    // Remove empty blocks, deepest first, a few passes
    for (let pass = 0; pass < 3; pass++) {
      [...root.querySelectorAll('p, div, span, h1, h2, h3, h4, h5, h6, li, ul, ol, strong, em, b')].reverse().forEach((n) => { if (blank(n)) n.remove(); });
    }
    // Lone <br> at the start or end of paragraphs
    root.querySelectorAll('p > br:first-child, p > br:last-child').forEach((n) => n.remove());

    if (opts.skipFirstImage) { const first = root.querySelector('img'); first && (first.closest('p, div') || first).remove(); }

    // Images become figures that open in the lightbox
    root.querySelectorAll('img').forEach((img) => {
      img.loading = 'lazy'; img.decoding = 'async';
      img.removeAttribute('width'); img.removeAttribute('height');
      const host = img.parentElement;
      const alone = host && host !== root && /^(P|DIV|SPAN|A|CENTER)$/.test(host.tagName) && host.children.length === 1 && !host.textContent.replace(/[\s ]/g, '');
      const fig = document.createElement('figure');
      fig.className = /\.gif(\?|$)/i.test(img.getAttribute('src') || '') ? 'tc-fig tc-fig--clip' : 'tc-fig'; fig.tabIndex = 0; fig.setAttribute('role', 'button'); fig.setAttribute('aria-label', `Open image${img.alt ? `: ${img.alt}` : ''}`);
      if (alone && host.tagName !== 'A') { host.replaceWith(fig); fig.append(img); }
      else if (host && host.tagName === 'A' && host.children.length === 1) { host.replaceWith(fig); fig.append(img); }
      else { img.replaceWith(fig); fig.append(img); }
      // Hoist figures out of paragraphs so they can sit full width
      const p = fig.parentElement;
      if (p && p !== root && p.tagName === 'P') p.after(fig);
    });
    // Runs of consecutive figures become a gallery
    let run = [];
    const flush = () => {
      if (run.length >= 2) {
        const g = document.createElement('div');
        g.className = `tc-gallery${run.length % 3 === 0 ? ' tc-gallery--3' : ''}`;
        run[0].before(g); run.forEach((f) => g.append(f));
      }
      run = [];
    };
    [...root.children].forEach((el) => { if (el.classList.contains('tc-fig')) run.push(el); else flush(); });
    flush();

    root.querySelectorAll('iframe').forEach((f) => facade(f, null, opts.videoLabel));
    root.querySelectorAll('table').forEach((t) => { if (!t.parentElement.classList.contains('tc-table')) { const w = document.createElement('div'); w.className = 'tc-table'; t.replaceWith(w); w.append(t); } });
    root.querySelectorAll('a[href^="http"]').forEach((a) => { if (!a.href.includes(location.hostname)) { a.target = '_blank'; a.rel = 'noopener'; } });
    const lead = [...root.children].find((el) => el.tagName === 'P' && el.textContent.trim().length > 80);
    lead && lead === root.firstElementChild && lead.classList.add('tc-lead');
  };

  /* ---------- Lightbox ---------- */
  let lb, lbList = [], lbIndex = 0;
  const lbShow = (i) => {
    lbIndex = (i + lbList.length) % lbList.length;
    const src = lbList[lbIndex];
    const img = lb.querySelector('.tc-lb__stage img');
    img.src = src.src.replace(/_(small|medium|large|grande|compact)\./, '.'); img.alt = src.alt || '';
    img.style.animation = 'none'; void img.offsetWidth; img.style.animation = '';
    lb.querySelector('[data-lb-count]').textContent = `${lbIndex + 1} / ${lbList.length}`;
    lb.querySelector('.tc-lb__cap').textContent = src.alt || '';
  };
  const lbOpen = (list, i) => {
    if (!lb) {
      lb = document.createElement('dialog');
      lb.className = 'tc-lb tc-learn'; lb.setAttribute('aria-label', 'Image viewer');
      lb.innerHTML = `<div class="tc-lb__top"><span data-lb-count></span><button type="button" data-lb-close aria-label="Close"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 1l12 12M13 1L1 13"/></svg></button></div>
        <div class="tc-lb__stage"><img alt=""></div><p class="tc-lb__cap"></p>
        <button type="button" class="tc-lb__nav tc-lb__nav--prev" data-lb-step="-1" aria-label="Previous image"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 6H2M6 1L1 6l5 5"/></svg></button>
        <button type="button" class="tc-lb__nav tc-lb__nav--next" data-lb-step="1" aria-label="Next image"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M0 6h14M10 1l5 5-5 5"/></svg></button>`;
      document.body.append(lb);
      lb.addEventListener('click', (e) => {
        const step = e.target.closest('[data-lb-step]');
        if (step) return lbShow(lbIndex + +step.dataset.lbStep);
        if (e.target.closest('[data-lb-close]') || e.target === lb || e.target.classList.contains('tc-lb__stage')) lb.close();
      });
      lb.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') lbShow(lbIndex + 1); if (e.key === 'ArrowLeft') lbShow(lbIndex - 1); });
      let sx = null;
      lb.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', (e) => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) lbShow(lbIndex + (dx < 0 ? 1 : -1)); sx = null; });
    }
    lbList = list;
    lb.querySelectorAll('.tc-lb__nav').forEach((b) => { b.hidden = list.length < 2; });
    lb.showModal(); lbShow(i);
  };
  const bindLightbox = (root) => {
    const figs = [...root.querySelectorAll('.tc-fig')];
    const imgs = figs.map((f) => f.querySelector('img'));
    figs.forEach((f, i) => {
      f.addEventListener('click', () => lbOpen(imgs, i));
      f.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbOpen(imgs, i); } });
    });
  };

  /* ---------- Reading progress ---------- */
  const words = (el) => (el.textContent.match(/\S+/g) || []).length;
  const progressOf = (el) => {
    const r = el.getBoundingClientRect();
    const span = r.height - window.innerHeight * 0.6;
    return span > 0 ? Math.min(Math.max((window.innerHeight * 0.4 - r.top) / span, 0), 1) : (r.top < window.innerHeight * 0.4 ? 1 : 0);
  };
  const onScroll = (fn) => { let t = false; const run = () => { t = false; fn(); }; addEventListener('scroll', () => { if (!t) { t = true; requestAnimationFrame(run); } }, { passive: true }); addEventListener('resize', run); run(); };

  /* ---------- Article ---------- */
  document.querySelectorAll('[data-tc-article]').forEach((root) => {
    const body = root.querySelector('[data-tc-prose]');
    if (!body) return;
    const label = root.dataset.videoLabel || 'Watch';
    clean(body, { videoLabel: label });
    // Video-led articles: lift the first video into the hero
    const slot = root.querySelector('[data-tc-hero-video]');
    const firstVideo = body.querySelector('.tc-embed:not(.tc-embed--raw)');
    if (slot && firstVideo && slot.dataset.poster !== undefined) {
      const poster = slot.dataset.poster;
      if (poster) { const im = firstVideo.querySelector('.tc-play img'); im && (im.src = poster); }
      slot.innerHTML = ''; slot.classList.add('has-video'); slot.append(firstVideo);
    }
    bindLightbox(body);
    const bar = document.querySelector('[data-tc-progress]');
    onScroll(() => { bar && bar.style.setProperty('--p', progressOf(body).toFixed(4)); });
  });

  /* ---------- Guide ---------- */
  document.querySelectorAll('[data-tc-guide]').forEach((root) => {
    const body = root.querySelector('[data-tc-prose]');
    if (!body) return;
    // Collect hero images before cleaning moves things around
    const pool = [...body.querySelectorAll('img')].slice(1).map((i) => i.getAttribute('src')).filter(Boolean);
    clean(body, { skipFirstImage: root.hasAttribute('data-skip-first-image'), videoLabel: 'Watch' });
    bindLightbox(body);

    // Fight clips for the mosaic and chapter cards. A Giphy GIF is about 4.6 MB; Giphy's own still
    // (about 30 KB) shows at once and its MP4 of the same clip (about 150 KB) plays over it.
    // ready() is called with the still, then again with the video once it plays.
    const giphy = (src) => { const m = (src || '').match(/giphy\.com\/media\/([\w-]+)\//); return m ? `https://media.giphy.com/media/${m[1]}/` : null; };
    const clip = (src, ready, fail) => {
      const g = giphy(src);
      const img = new Image(); img.alt = ''; img.decoding = 'async';
      img.onload = () => {
        ready(img);
        if (!g || reduce) return;
        const v = document.createElement('video');
        v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.preload = 'auto';
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
        v.addEventListener('playing', () => ready(v), { once: true });
        v.src = `${g}giphy.mp4`;
        v.play().catch(() => {});
      };
      img.onerror = () => { if (g && img.src !== src) img.src = src; else if (fail) fail(); };
      img.src = g ? `${g}480w_s.jpg` : src;
    };

    // Hero mosaic: real images and clips from the guide, rotating slowly
    const tiles = [...root.querySelectorAll('.tc-gd__tile')];
    const mosaic = root.querySelector('.tc-gd__mosaic');
    if (tiles.length && pool.length) {
      const gifs = pool.filter((s) => /\.gif/i.test(s)), stills = pool.filter((s) => !/\.gif/i.test(s));
      // Fight clips only; the stills are mostly diagrams that read badly as a mosaic
      const order = gifs.length >= 6 ? gifs : gifs.concat(stills);
      let cursor = 0;
      const put = (tile) => {
        if (tile.dataset.busy) return; // the last clip for this tile is still loading
        const src = order[cursor++ % order.length];
        tile.dataset.busy = '1';
        clip(src, (el) => {
          delete tile.dataset.busy;
          tile.append(el); tile.classList.toggle('is-live', /\.gif/i.test(src));
          requestAnimationFrame(() => el.classList.add('is-on'));
          const old = [...tile.children].filter((o) => o !== el);
          setTimeout(() => old.forEach((o) => o.remove()), 1200);
        }, () => { delete tile.dataset.busy; });
      };
      tiles.forEach(put);
      if (!reduce && order.length > tiles.length) {
        let k = 0;
        setInterval(() => {
          if (document.hidden || (mosaic && mosaic.getBoundingClientRect().bottom < 0)) return;
          put(tiles[k++ % tiles.length]);
        }, 2600);
      }
    }

    // Letter-spaced headings such as "P A U S E" / "U N P A U S E" bracket an aside; they are markers, not chapters
    body.querySelectorAll('h2').forEach((h) => {
      const t = h.textContent.trim();
      if (!/^(\S )+\S$/.test(t)) return;
      const m = document.createElement('p'); m.className = 'tc-gd__mark'; m.textContent = t.replace(/ /g, '').toLowerCase();
      h.replaceWith(m);
    });

    // Chapters
    const heads = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
    const n = heads.length;
    const pad = (k) => String(k).padStart(2, '0');
    const chapters = heads.map((h, i) => {
      const title = h.textContent.trim().replace(/\s+/g, ' ');
      const id = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `chapter-${i + 1}`;
      const sec = document.createElement('section');
      sec.className = 'tc-chap'; sec.id = id; sec.setAttribute('aria-labelledby', `${id}-h`);
      h.id = `${id}-h`;
      h.before(sec);
      const head = document.createElement('header'); head.className = 'tc-chap__head';
      head.innerHTML = `<div class="tc-chap__media" aria-hidden="true"></div><div class="tc-chap__copy"><span class="tc-chap__label"><b>Chapter ${pad(i + 1)}</b> / ${pad(n)}</span></div>`;
      head.querySelector('.tc-chap__copy').append(h);
      sec.append(head);
      let next = sec.nextSibling;
      while (next && !(next.nodeType === 1 && next.tagName === 'H2' && heads.includes(next))) { const cur = next; next = next.nextSibling; sec.append(cur); }
      // The chapter's first fight clip plays behind its title (loaded when the chapter comes near)
      const first = sec.querySelector('.tc-fig--clip img');
      const clipSrc = first ? first.getAttribute('src') : null;
      if (clipSrc) head.classList.add('has-media');
      return { id, title, sec, head, clipSrc };
    });
    // Text before the first chapter becomes the introduction
    const firstChap = chapters[0] && chapters[0].sec;
    if (firstChap && firstChap.previousElementSibling) {
      const intro = document.createElement('section'); intro.className = 'tc-gd__intro-sec';
      body.prepend(intro);
      while (intro.nextElementSibling && intro.nextElementSibling !== firstChap) intro.append(intro.nextElementSibling);
      const lead = intro.querySelector('p'); lead && lead.classList.add('tc-lead');
    }
    // End of each chapter: a large link to the next one
    chapters.forEach((c, i) => {
      const nx = chapters[i + 1];
      const a = document.createElement('a');
      a.className = 'tc-chap__next';
      if (nx) { a.href = `#${nx.id}`; a.dataset.chap = i + 1; a.innerHTML = `<span>Next chapter</span><b>${nx.title}</b><i aria-hidden="true">${pad(i + 2)}</i>`; }
      else { a.href = '#'; a.dataset.top = ''; a.innerHTML = `<span>End of the guide</span><b>Back to the top</b><i aria-hidden="true">${pad(1)}</i>`; }
      c.sec.append(a);
    });

    const total = words(body);
    root.querySelectorAll('[data-tc-chapcount]').forEach((el) => { el.textContent = n; });
    root.querySelectorAll('[data-tc-readtime]').forEach((el) => { el.textContent = Math.max(Math.round(total / WPM), 1); });

    const listHTML = chapters.map((c, i) => `<li><a href="#${c.id}" data-chap="${i}"><span>${pad(i + 1)}</span><span>${c.title}</span></a></li>`).join('');
    root.querySelectorAll('[data-tc-toc]').forEach((ol) => { ol.innerHTML = listHTML; });
    const links = [...root.querySelectorAll('.tc-gd__toc [data-chap]')];
    const sheet = root.querySelector('[data-tc-sheet]');

    // Jump to a chapter and hold it in place while images above it finish loading
    // Land just below the header when it is showing, near the top when it is tucked away
    const offsetNow = () => { const b = document.querySelector('tc-header .tc-bar'); const r = b && b.getBoundingClientRect(); return (r && r.bottom > 0 ? r.bottom : 0) + 16; };
    let settleTimer = null, userMoved = false;
    ['wheel', 'touchstart', 'keydown'].forEach((ev) => addEventListener(ev, () => { userMoved = true; }, { passive: true }));
    const jumpTo = (el) => {
      clearInterval(settleTimer); userMoved = false;
      const target = () => Math.max(el.getBoundingClientRect().top + window.scrollY - offsetNow(), 0);
      // Start loading the images just above the target so the page settles sooner
      let prev = el.previousElementSibling, k = 0;
      while (prev && k < 2) { prev.querySelectorAll('img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; }); prev = prev.previousElementSibling; k++; }
      // Cut straight to the section (no long scroll), with a quick fade so the change reads as intentional
      const stage = root.querySelector('.tc-gd__layout');
      const land = () => {
        window.scrollTo({ top: target(), behavior: 'instant' });
        requestAnimationFrame(() => { window.scrollTo({ top: target(), behavior: 'instant' }); stage && stage.classList.remove('is-cut'); });
      };
      if (stage && !reduce) { stage.classList.add('is-cut'); setTimeout(land, 140); } else land();
      const started = performance.now();
      settleTimer = setInterval(() => {
        const t = performance.now() - started;
        if (userMoved || t > 4500) { clearInterval(settleTimer); return; }
        if (t > 300 && Math.abs(el.getBoundingClientRect().top - offsetNow()) > 6) window.scrollTo({ top: target(), behavior: 'instant' });
      }, 120);
    };
    const go = (a, e) => {
      e.preventDefault();
      const top = a.hasAttribute('data-top');
      const c = top ? null : chapters[+a.dataset.chap];
      const run = () => { jumpTo(top ? root : c.sec); history.replaceState(null, '', top ? location.pathname + location.search : `#${c.id}`); };
      if (sheet && sheet.open) { sheet.close(); setTimeout(run, 30); } else run();
    };
    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-chap], a[data-top]');
      if (a && root.contains(a)) go(a, e);
    });
    root.querySelectorAll('a[href="#tc-guide-body"]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); jumpTo(root.querySelector('#tc-guide-body')); }));

    const bar = document.querySelector('[data-tc-progress]');
    const tocProg = root.querySelector('[data-tc-tocprog]');
    const pbar = root.querySelector('[data-tc-chapbar]');
    const pbtn = pbar && pbar.querySelector('button');
    const ptitle = root.querySelector('[data-tc-bar-title]');
    const pmeta = root.querySelector('[data-tc-bar-meta]');
    let active = -2;
    onScroll(() => {
      const p = progressOf(body);
      bar && bar.style.setProperty('--p', p.toFixed(4));
      tocProg && tocProg.style.setProperty('--p', p.toFixed(4));
      const vh = window.innerHeight;
      let a = -1;
      chapters.forEach((c, i) => {
        const r = c.sec.getBoundingClientRect();
        const cp = Math.min(Math.max((vh * 0.3 - r.top) / Math.max(r.height, 1), 0), 1);
        links.forEach((l) => { if (+l.dataset.chap === i) { l.style.setProperty('--p', cp.toFixed(3)); l.classList.toggle('is-done', cp >= 1); } });
        if (r.top < vh * 0.3) a = i;
        c.head.classList.toggle('is-in', r.top < vh * 0.88);
        if (c.clipSrc && r.top < vh * 1.6 && r.bottom > -vh) {
          const media = c.head.querySelector('.tc-chap__media');
          c.clipSrc = (clip(c.clipSrc, (el) => { const old = [...media.children]; media.append(el); setTimeout(() => old.forEach((o) => o.remove()), 1200); }), null);
        }
      });
      if (a !== active) {
        active = a;
        root.querySelectorAll('[data-tc-toc] a').forEach((l) => { const on = +l.dataset.chap === a; l.classList.toggle('is-active', on); if (on) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current'); });
        if (ptitle) ptitle.textContent = a >= 0 ? chapters[a].title : 'Introduction';
        if (pmeta) pmeta.textContent = a >= 0 ? `${pad(a + 1)} / ${pad(n)}` : `${pad(n)} chapters`;
        const tocIn = root.querySelector('.tc-gd__toc-in');
        const tocActive = tocIn && tocIn.querySelector('a.is-active');
        if (tocIn && tocActive) { const tr = tocActive.getBoundingClientRect(), cr = tocIn.getBoundingClientRect(); if (tr.top < cr.top || tr.bottom > cr.bottom) tocIn.scrollTop += tr.top - cr.top - cr.height / 3; }
      }
      if (pbtn) pbtn.style.setProperty('--p', p.toFixed(4));
      if (pbar) { const r = body.getBoundingClientRect(); pbar.classList.toggle('is-on', r.top < vh * 0.5 && r.bottom > vh * 0.6); }
    });
    pbtn && sheet && pbtn.addEventListener('click', () => sheet.showModal());
    sheet && sheet.addEventListener('click', (e) => { if (e.target === sheet || e.target.closest('[data-sheet-close]')) sheet.close(); });
    if (location.hash) { const t = document.getElementById(decodeURIComponent(location.hash.slice(1))); t && setTimeout(() => jumpTo(t), 80); }
  });

  /* ---------- Blog search ---------- */
  document.querySelectorAll('[data-tc-blog-search]').forEach((input) => {
    const scope = input.closest('[data-tc-blog]');
    const cards = [...scope.querySelectorAll('[data-tc-card]')];
    const feat = scope.querySelector('[data-tc-feat]');
    const band = scope.querySelector('[data-tc-band]');
    const empty = scope.querySelector('[data-tc-empty]');
    const count = scope.querySelector('[data-tc-count]');
    const grid = scope.querySelector('.tc-bl__grid');
    const items = cards.map((card) => ({ card, item: card.closest('[data-tc-blog-item]') || card.parentElement }));
    let lastMatches = null;
    const animations = new Map();
    const filter = (animate = true) => {
      const q = input.value.trim().toLowerCase();
      const before = new Map(items.filter(({ item }) => !item.hidden).map(({ item }) => [item, item.getBoundingClientRect()]));
      animations.forEach((animation) => animation.cancel()); animations.clear();
      let shown = 0;
      items.forEach(({ card, item }) => {
        const hit = !q || card.dataset.q.includes(q);
        item.hidden = !hit; card.hidden = !hit;
        if (hit) { shown++; item.classList.add('is-in'); item.style.setProperty('--tc-i', 0); }
      });
      if (grid) grid.hidden = shown === 0;
      if (feat) feat.hidden = !!q && !feat.dataset.q.includes(q);
      if (feat && !feat.hidden) shown++;
      if (band) band.hidden = !!q;
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = q ? (shown === 1 ? scope.dataset.resultOne : scope.dataset.resultOther).replace('__COUNT__', shown) : '';
      const matches = items.filter(({ item }) => !item.hidden).map(({ item }) => item);
      const changed = !lastMatches || matches.length !== lastMatches.length || matches.some((item, i) => item !== lastMatches[i]);
      lastMatches = matches;
      if (!animate || !changed || matchMedia('(prefers-reduced-motion: reduce)').matches || scope.dataset.tcBlogMotion === 'false' || document.documentElement.dataset.tcReveals === 'off') return;
      matches.forEach((item) => {
        const next = item.getBoundingClientRect(), old = before.get(item);
        if (next.bottom < 0 || next.top > innerHeight) return;
        const x = old ? Math.max(-80, Math.min(80, old.left - next.left)) : 0;
        const y = old ? Math.max(-40, Math.min(40, old.top - next.top)) : 6;
        animations.set(item, item.animate([
          { opacity: old ? 1 : 0, transform: `translate(${x}px, ${y}px)` },
          { opacity: 1, transform: 'none' }
        ], { duration: 220, easing: 'cubic-bezier(.2,.7,0,1)' }));
      });
    };
    input.addEventListener('input', () => filter());
    if (input.value) filter(false);
    addEventListener('pageshow', (e) => { if (e.persisted || input.value) filter(false); });
  });

  /* ---------- Share ---------- */
  document.querySelectorAll('[data-tc-copy]').forEach((btn) => btn.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(location.href.split('#')[0].split('?')[0]); btn.classList.add('is-copied'); btn.setAttribute('aria-label', 'Link copied'); setTimeout(() => { btn.classList.remove('is-copied'); btn.setAttribute('aria-label', 'Copy link'); }, 1800); } catch (e) { /* clipboard blocked */ }
  }));
})();
